import { getData, postData } from "@/lib/request";

export const getListSearchingPb = (params) =>
  getData("web/project/getListSearchingPb", params);
